import React from 'react'
import styled from 'styled-components'
import Typography, {TypographyProps} from '@mui/material/Typography'
import content_headerStyles from './content_header.styles'

const apAtomName = {ap_atom_name: 'contentHeaderAtom'}
const ContentHeaderAtom = styled((props: TypographyProps) => (
  <Typography {...apAtomName} {...props} />
))`
  ${content_headerStyles}
`

export default ContentHeaderAtom
